import type { BackendRouteDefinition } from '../types';

export const addPaymentInstrumentForFirmAsBuyerRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/buyer/payment-instruments',
} as const satisfies BackendRouteDefinition;
